
export default {
  state: {
  },
  mutations: {
  }
};
